import {
  TableRow,
  TableCell
} from '@mui/material';

import { useAuthStore } from '../stores/useAuthStore';
import { buildLineTableData } from '../utils/export/buildLineTableData';
import { useTurnosStore } from '../stores/useTurnosStore';
import { useLinesStore } from '../stores/useLinesStore';

const LineTableRow = ({ line }) => {
  
 const perfisDisponiveis = useAuthStore(state => state.perfisDisponiveis);

 const turnosMap = useTurnosStore(state => state.turnosMap);

 const turnoNome = turnosMap.get(
      Number(line?.turno) || 0
  )?.nome ?? ' - ';

  const metrosTotalRotaMap = useLinesStore(state => state.metrosTotalRotaMap);

  const kmTotalRota = Math.round(
      (
          metrosTotalRotaMap.get(line?.CODIGO_INTEGRACAO) ?? 0
      ) / 1000
  );

  const rowData =
    buildLineTableData({
      line,
      perfisDisponiveis,
      kmTotalRota,
      turnoNome
    });

  return (
    <TableRow hover>

      <TableCell align='center'>
        {rowData.Linha}
      </TableCell>

      <TableCell align='center'>
        {rowData.Sentido}
      </TableCell>

      <TableCell align='center'>
        {rowData.Cliente}
      </TableCell>

      <TableCell align='center'>
        {rowData['Unidade Operacional']}
      </TableCell>

      <TableCell align='center'>
        {rowData['Turno']}
      </TableCell>

      <TableCell align='center'>
        {rowData['Código de Integração']}
      </TableCell>

      <TableCell align='center'>
        {rowData['KM Previsto']}
      </TableCell>

    </TableRow>
  );

};

export default LineTableRow;